module.exports = __webpack_public_path__ + "static/error-bg-10a112643fdb343fc81ce59ab01c18c6.jpg";